import script from "./ClaimsListTableRowNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimsListTableRowNew.vue?vue&type=script&setup=true&lang=js"

import "./ClaimsListTableRowNew.vue?vue&type=style&index=0&id=eea39a68&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eea39a68"]])

export default __exports__